import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";

export class PaginatorIntlService extends MatPaginatorIntl {
  translateService: TranslateService;

  getRangeLabel = function (page, pageSize, length) {
    if (length === 0 || pageSize === 0) {
      return "0 de " + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return startIndex + 1 + " - " + endIndex + " de " + length;
  };

  injectTranslateService(translate: TranslateService) {
    this.translateService = translate;
    this.translateLabels();

    this.translateService.onLangChange.subscribe(() => {
      this.translateLabels();
    });
  }

  translateLabels() {
    this.firstPageLabel = this.translateService.instant("paginator.FIRST_PAGE");
    this.itemsPerPageLabel = this.translateService.instant(
      "paginator.ITEMS_PER_PAGE"
    );
    this.lastPageLabel = this.translateService.instant("paginator.LAST_PAGE");
    this.nextPageLabel = this.translateService.instant("paginator.NEXT_PAGE");
    this.previousPageLabel = this.translateService.instant(
      "paginator.PREVIOUS_PAGE"
    );
    this.changes.next(); // Fire a change event to make sure that the labels are refreshed
  }
}
